<template>
  <div class="pd1-means">

    <div
      class="pd1-means-item"
      v-for="(item, index) in serviceList"
      :key="index"
      @click="goFile(item)"
    >
      {{ item.service_type_name }} {{ item.time }}
    </div>
  </div>
</template>

<script>
import pd1Service from "@/apis/pd1/index.js";
import moment from "moment";

export default {
  data() {
    return {
      serviceList: [],
    };
  },
  created() {
    this.getServiceList();
  },
  methods: {
    getServiceList() {
      const params = {
        work_id: this.$route.query.work_id,
      };
      pd1Service.serviceList(params).then((res) => {
        res.forEach((item) => {
          item.time = moment(item.create_time).format("YYYY-MM-DD HH:mm");
        });
        this.serviceList = res;
        console.log(res);
      });
    },

    goFile(item) {
      this.$router.push({
        name: "Pd1File",
        query: {
          work_id: this.$route.query.work_id,
          service_id: item.service_id,
          service_type: item.service_type,
          service_expert_type: item.service_type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pd1-means {
  .pd1-means-item {
    padding: 10px 15px;
  }
}
</style>